import React from 'react'
import styles from './RegisteredOffice.module.scss'

const RegisteredOffice = () => {
  return (
    <div className={styles['registered-office']}>
      <div className={styles['card']}>
        <div className={styles['icon-wrapper']}>
          <svg
            viewBox='0 0 24 24'
            fill='none'
            strokeWidth={2}
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z' />
            <circle cx='12' cy='10' r='3' />
          </svg>
        </div>
        <div className={styles['content']}>
          <p className={styles['label']}>Find us at</p>
          <p className={styles['title']}>Registered Office</p>
          <p className={styles['address']}>
            B13, 14, Shaheed Major Vikas Yadav Marg, Prem Puri, Sector 32,
            Gurugram, Haryana 122001, India
          </p>
        </div>
      </div>
    </div>
  )
}

export default RegisteredOffice
